import { useQuery } from '@tanstack/react-query';

import { agent } from 'api/agent';
import { EfficiencyProps } from 'utils/types';

export const fileKey = ['fileEfficiency'];

const useCroptimizerEfficiency = () => useQuery({
  queryKey: [fileKey, 'croptimizer'],
  queryFn: () => agent.getClient()('file-data/croptimizer?tag=efficiency').then((response) => {
    const result: EfficiencyProps[] = [];
    response?.data?.data?.forEach((element: any) => {
      result.push({
        ['CAP']: element?.['0'],
        ['S/CEC']: element?.['1'],
        ['pH']: element?.['2'],
      });
    });

    return result as EfficiencyProps[];
  }),
});

export default useCroptimizerEfficiency;
